var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.level._id ? _c('span', [_vm._v("회원등급 상세")]) : _c('span', [_vm._v("회원등급 등록")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-layout', {
    staticClass: "mx-n2"
  }, [_c('v-flex', {
    staticClass: "px-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "회원등급명칭",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.level.name,
      callback: function callback($$v) {
        _vm.$set(_vm.level, "name", $$v);
      },
      expression: "level.name"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "회원등급코드",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.level.code,
      callback: function callback($$v) {
        _vm.$set(_vm.level, "code", $$v);
      },
      expression: "level.code"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("포인트 적립")])]), _c('v-card-text', [_c('v-layout', {
    staticClass: "mx-n2"
  }, [_c('v-flex', {
    staticClass: "px-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "포인트 적립률",
      "persistent-placeholder": "",
      "hide-details": "",
      "suffix": "%"
    },
    model: {
      value: _vm.level.pointPercent.purchase,
      callback: function callback($$v) {
        _vm.$set(_vm.level.pointPercent, "purchase", $$v);
      },
      expression: "level.pointPercent.purchase"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "ml-2 caption primary--text"
  }, [_vm._v("* 상품구매시 포인트를 적립을 설정합니다.")])])], 1), _vm.$route.params._level ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("회원목록")]), _c('v-divider'), _c('v-data-table', {
    attrs: {
      "items": _vm.members,
      "headers": _vm.membersHeaders,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "header.loginFailedCount",
      fn: function fn(_ref) {
        var header = _ref.header;
        return [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('div', [_vm._v("로그인"), _c('br'), _vm._v("실패횟수")])])];
      }
    }, {
      key: "item.phone",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.phone ? _c('span', [_vm._v(_vm._s(item.phone.phoneNumberFormat()))]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "item.isAutoBlock",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-switch', {
          staticClass: "pa-0 ma-0 d-inline-block",
          attrs: {
            "hide-details": "",
            "color": "red lighten-2",
            "disabled": ""
          },
          model: {
            value: item.isAutoBlock,
            callback: function callback($$v) {
              _vm.$set(item, "isAutoBlock", $$v);
            },
            expression: "item.isAutoBlock"
          }
        })];
      }
    }, {
      key: "item.isBlock",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-switch', {
          staticClass: "pa-0 ma-0 d-inline-block",
          attrs: {
            "hide-details": "",
            "color": "red lighten-2",
            "disabled": ""
          },
          model: {
            value: item.isBlock,
            callback: function callback($$v) {
              _vm.$set(item, "isBlock", $$v);
            },
            expression: "item.isBlock"
          }
        })];
      }
    }, {
      key: "item.isDormancy",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-switch', {
          staticClass: "pa-0 ma-0 d-inline-block",
          attrs: {
            "hide-details": "",
            "color": "red lighten-2",
            "disabled": ""
          },
          model: {
            value: item.isDormancy,
            callback: function callback($$v) {
              _vm.$set(item, "isDormancy", $$v);
            },
            expression: "item.isDormancy"
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c('v-icon', {
          staticClass: "ml-3",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.withdrawal(item);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }, {
      key: "item.cash",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_vm._v(_vm._s(item.cash.format()))];
      }
    }, {
      key: "item.point",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(_vm._s(item.point.format()))];
      }
    }, {
      key: "item.loginFailedCount",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_vm._v(" " + _vm._s(item.loginFailedCount[_vm.$dayjs().format("YYYY-MM-DD")] || 0) + " / 5 ")];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD")))];
      }
    }, {
      key: "item.visitedAt",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.visitedAt).format("YYYY-MM-DD")))];
      }
    }], null, false, 3973733136)
  }), _c('v-divider'), _c('v-card-actions', [_c('v-pagination', {
    staticClass: "mx-auto",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }